import {FC} from 'react'
import {RemoveDiscount} from '../discount'

interface Props {
  freeShipCode?: string
  freeShippingDiscountCodeId: string
  onRemoveDiscount: () => void
}

const FreeShipping: FC<Props> = ({freeShipCode, freeShippingDiscountCodeId, onRemoveDiscount}) => {
  return (
    <div className='p-0 btn-link text-decoration-none'>
      {freeShipCode ? (
        <RemoveDiscount
          title={freeShipCode}
          onRemoveDiscount={onRemoveDiscount}
          discountCodeId={freeShippingDiscountCodeId}
        />
      ) : (
        <div className='p-0 bg-transparent fw-bolder text-wrap'>Free</div>
      )}
    </div>
  )
}

export default FreeShipping
